import { setTheme } from "theme/default/setTheme";

export const setColor_1e70bf = setTheme(({ theme }) => `color: ${theme.colors.color_1e70bf}`);
